export function getMaskPhone(phone:any) {
  const str = String(phone).replace(/\s/g, '');
  if (str.length <= 7) {
    return '*'.repeat(str.length);
  }
  const s = String(phone ?? '').trim()
  return s.slice(0,3) + '****' + s.slice(-4)
}